__turbopack_context__.v({
  "active": "index-module__4KoG9G__active",
  "link": "index-module__4KoG9G__link",
});
